import { logout } from "./Auth__Service";
import { LOCAL_STORAGE_NAME } from "./config";

export function removeItem(itemToRemove) {
  window.localStorage.removeItem(itemToRemove);
}

export function getItem(item) {
  return window.localStorage.getItem(item);
}

export function addItem(loacalStorageName, newItem) {
  window.localStorage.setItem(loacalStorageName, newItem);
  let oldValue = getItem(LOCAL_STORAGE_NAME);
  let interval_id = setInterval(() => {
    const newValue = getItem(LOCAL_STORAGE_NAME);
    if (newValue === oldValue) {
      clearInterval(interval_id);
      logout();
    }
  }, 300000); // 5min
}
